export const InvalidUserAgentError = new Error('UserAgent not instantiated.')
export const StoppedUserAgentError = new Error('UserAgent is stopped.')
export const InvalidRegistererError = new Error('Registerer not instantiated.')
